import React from "react";
import {FormattedMessage} from "react-intl";
import images from "../../../images/dashboard";
import {Progress} from "reactstrap";
import {Link} from "react-router-dom";

class CategoryCard extends React.Component {
    render() {
        const { progress, category, id, link = `/${id}` } = this.props;
        return (
            <div className='card bg-gasnet-green'>
                <div className={`overview-cards__${id}__image`}>
                    <img className='img-fluid' src={images.content_units[category].illustration_big}/>
                </div>
                <Progress color='gasnet-green-dark' value={progress} max={1}/>
                <div className='card-body text-center'>
                    <FormattedMessage id={`app.dashboard.${category}`}>{(txt) => (<h3>{txt}</h3>)}</FormattedMessage>
                    <p><FormattedMessage id={`app.dashboard.${category}.text`}/></p>
                    <Link to={link} className='btn btn-white'><FormattedMessage id='app.dashboard.display_list'/></Link>
                </div>
            </div>
        )
    };
}

export default CategoryCard;
